import { useSuspenseQuery } from '@tanstack/react-query';
import { getReferral } from '@actions';
import { useDispatch } from 'react-redux';
import { useSessionAppointmentId } from '@hooks/useSessionAppointmentId';
import { useSessionAppointment } from '@hooks/useSessionAppointment';

const useApptReferral = () => {
  const dispatch = useDispatch();
  const { appointment } = useSessionAppointment();
  const appointmentId = useSessionAppointmentId(true);

  const {
    data: referral,
    status: referralStatus,
    isLoading
  } = useSuspenseQuery({
    queryKey: ['referral', appointmentId, appointment.appointment_completed],
    queryFn: () => dispatch(getReferral(appointmentId)),
    select: (data) => data.users?.[0]
  });

  return { referral, referralStatus, isLoadingReferral: isLoading };
};

export default useApptReferral;
